
    import { defineComponent, PropType, computed } from 'vue'
    import { buildLocalization } from '@/util'
    import IconLightGreen from '@/img/icon-light-green.svg'
    import IconLightYellow from '@/img/icon-light-yellow.svg'
    import IconLightRed from '@/img/icon-light-red.svg'
    import IconLink from '@/img/icon-link.svg'
    import router from '@/router'
    import { PartnerEquipmentRow } from '@/types/equipment'

    export default defineComponent({
        name: 'softwareVersionCell',

        props: {
            row: { type: Object as PropType<PartnerEquipmentRow>, required: true }
        },

        setup(props) {
            /********************************************************************************************************************
             COMPUTED
             ********************************************************************************************************************/
            const installedVersion = computed(() => props.row.installedVersion)
            const isUpToDate = computed(() => props.row.isUpToDate)
            const isMinorUpgrade = computed(() => props.row.isMinorUpgrade)
            const isMajorUpgrade = computed(() => props.row.isMajorUpgrade)
            const isUpgradeAvailable = computed(() => props.row.isUpgradeAvailable)

            const statusIcon = computed(() => {
                if (!installedVersion.value || installedVersion.value == '-') return null
                if (isUpToDate.value) return IconLightGreen
                if (isMinorUpgrade.value) return IconLightYellow
                if (isMajorUpgrade.value) return IconLightRed
                return null
            })

            const tooltip = computed(() => {
                if (isMinorUpgrade.value) return localize('MinorUpgradeAvailable')
                if (isMajorUpgrade.value) return localize('ImportantUpgradeAvailable')
                return ''
            })

            const displayVersion = computed(() => installedVersion.value)
            const showUpdateIcon = computed(() => isUpgradeAvailable.value)

            const computedData = {
                statusIcon,
                tooltip,
                displayVersion,
                showUpdateIcon
            }

            /********************************************************************************************************************
             PUBLIC METHODS
             ********************************************************************************************************************/
            const { localize } = buildLocalization()

            function goToUpdate() {
                router.push({ name: 'equipment-software', params: { sn: props.row.serialNo } })
            }

            const publicMethods = { localize, goToUpdate }

            /********************************************************************************************************************
             COMPONENT INTERFACE
             ********************************************************************************************************************/
            return {
                ...computedData,
                ...publicMethods,
                iconLink: IconLink
            }
        }
    })
